import React from 'react';
import {
  getFullUSDate,
  ITEMS_PER_PAGE,
  sortAlphabeticallyByKey,
  // sortAlphabeticallyByName,
  // sortBooleanByKey,
  sortUpdatedAt,
  State,
} from '../utils';
import { SortOrder } from 'antd/lib/table/interface';
import styles from '../../pages/Pages.module.css';
import { Table } from 'antd';
import { useHistory } from 'react-router';
import useGiideList from '../../hooks/useQuery/useGiideList';
import useGiideListPagination from '../../hooks/useGiideListPagination';

const GiideListTable: React.FC = () => {
  const { push } = useHistory();
  const { filteredData, giideListSortType, handleSortChange } =
    useGiideList(true);
  const { paginationPage, handlePageChange, paginationButtonsRender } =
    useGiideListPagination();

  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      sorter: {
        compare: sortAlphabeticallyByKey('title'),
      },
      sortOrder: (giideListSortType?.type === 'Title' &&
      !giideListSortType?.descending
        ? 'ascend'
        : giideListSortType?.type === 'Title' && giideListSortType?.descending
        ? 'descend'
        : '') as SortOrder,
      onHeaderCell: column => {
        return {
          onClick: () => handleSortChange('Title'),
        };
      },
    },
    /*    {
      title: 'Author',
      dataIndex: 'speaker',
      sorter: {
        compare: sortAlphabeticallyByName,
      },
      sortOrder: (giideListSortType?.type === 'Author' &&
      !giideListSortType?.descending
        ? 'ascend'
        : giideListSortType?.type === 'Author' && giideListSortType?.descending
        ? 'descend'
        : '') as SortOrder,
      render: (data, row) => (
        <span>{data && data['fullName'] ? data['fullName'] : ''}</span>
      ),
      width: '150pt',
      onHeaderCell: column => {
        return {
          onClick: () => handleSortChange('Author'),
        };
      },
    },*/
    {
      title: 'Status',
      dataIndex: 'publishState',
      sorter: {
        compare: sortAlphabeticallyByKey('publishState'),
      },
      sortOrder: (giideListSortType?.type === 'Status' &&
      !giideListSortType?.descending
        ? 'ascend'
        : giideListSortType?.type === 'Status' && giideListSortType?.descending
        ? 'descend'
        : '') as SortOrder,
      render: (data, row) => <span>{State[data || 'unpublished']}</span>,
      width: '75pt',
      onHeaderCell: column => {
        return {
          onClick: () => handleSortChange('Status'),
        };
      },
    },
    {
      title: 'Last Edited',
      dataIndex: 'updatedAt',
      sorter: {
        compare: sortUpdatedAt,
      },
      sortOrder: (giideListSortType?.type === 'Last Edited' &&
      !giideListSortType?.descending
        ? 'ascend'
        : giideListSortType?.type === 'Last Edited' &&
          giideListSortType?.descending
        ? 'descend'
        : '') as SortOrder,
      render: (data, row) => <span> {data ? getFullUSDate(data) : ''}</span>,
      width: '150pt',
      onHeaderCell: column => {
        return {
          onClick: () => handleSortChange('Last Edited'),
        };
      },
    },
    // {
    //   title: 'Visibility',
    //   dataIndex: 'unauthenticatedAccessAllowed',
    //   sorter: {
    //     compare: sortBooleanByKey('unauthenticatedAccessAllowed'),
    //   },
    //   sortOrder: (giideListSortType?.type === 'Visibility' &&
    //   !giideListSortType?.descending
    //     ? 'ascend'
    //     : giideListSortType?.type === 'Visibility' &&
    //       giideListSortType?.descending
    //     ? 'descend'
    //     : '') as SortOrder,
    //   render: (data, row) => <span>{data ? 'Public' : 'Private'}</span>,
    //   width: '75pt',
    //   onHeaderCell: column => {
    //     return {
    //       onClick: () => handleSortChange('Visibility'),
    //     };
    //   },
    // },
  ];

  return (
    <Table
      className={`listView ${styles.listView}`}
      columns={columns}
      dataSource={filteredData}
      sortDirections={['ascend', 'descend', 'ascend']}
      showSorterTooltip={false}
      pagination={{
        defaultCurrent: paginationPage?.page ?? 1,
        defaultPageSize: ITEMS_PER_PAGE,
        showSizeChanger: false,
        itemRender: paginationButtonsRender,
        position: ['bottomCenter'],
        onChange: handlePageChange,
        hideOnSinglePage: true,
      }}
      onRow={(giide, rowIndex) => {
        return {
          onClick: event => {
            push(`/giide/${giide.id}`);
          },
        };
      }}
    />
  );
};

export default GiideListTable;
